export const baseUrl = "http://localhost:30002";
// export const baseUrl = "http://13.54.97.53:30002";
// export const baseUrl = "https://api.nangman.day";
export const headers = {
  Accept: "application/json",
  "Content-Type": "application/json;charset=UTF-8",
  "Access-Control-Allow-Origin": "*",
  "X-Content-Type-Options": "nosniff",
};
